import MoneyMovementLocationsSection from '../../money-movement-locations-section/money-movement-locations-section.component';
import { useTranslation } from 'react-i18next';
import { AchLocationType } from 'api/giftcard-ach-service/giftcard-ach-service.types';

type LocationsSectionProps = {
  locations: AchLocationType[];
  isLoading?: boolean;
};

const LocationsSection = ({ locations, isLoading }: LocationsSectionProps) => {
  const { t } = useTranslation();

  return (
    <MoneyMovementLocationsSection
      title={t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.locations.title',
      )}
      locations={locations}
      transferTypeTitle={t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.headers.enableFundTransfers',
      )}
      data-testid="LocationsSection"
      isLoading={isLoading}
    />
  );
};

export default LocationsSection;
